import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'About';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`,
    INVIEW: `inview.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        this.$el.on(EVENT.INVIEW, (e) => this.setInview(e));
        $('.js-about-item').on(EVENT.CLICK, (e) => this.setActive(e));
    }

    setInview(e) {
        if (e.way == 'enter') {
            const id = $(e.target).attr('id');
            $('.js-about-item.is-active').removeClass('is-active');
            $('.js-about-item[href="#' + id + '"]').addClass('is-active');
        }
    }

    setActive(e) {
        $('.js-about-item.is-active').removeClass('is-active');
        $(e.currentTarget).addClass('is-active');
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
